import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Shared axios instance for backend calls.
// `withCredentials: true` sends the session_token cookie set by the backend.
export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});
